export default __webpack_public_path__ + "static/3-new-order-aa1a3c4b41bdfdc41e07fd465f5a3194.png";